import React from "react";
import { Box, Typography, Button } from "@mui/material";

import StatusChip from "../Common/StatusChip";

export default function WorkshopCard({
    title,
    duration,
    seats,
    status,
    buttonText,
    onAction,
}) {
    return (
        <Box
            sx={{
                backgroundColor: "#F7F8FC",
                border: "1px solid #E8EDF5",
                borderRadius: "12px",
                p: 2,
                mb: 2,
                transition: "all .2s ease",

                "&:hover": {
                    backgroundColor: "#F5F7FB",
                },

                "&:last-child": {
                    mb: 0,
                },
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                }}
            >
                <Typography
                    sx={{
                        fontSize: 15,
                        fontWeight: 600,
                        color: "#1E293B",
                    }}
                >
                    {title}
                </Typography>

                <StatusChip status={status} />
            </Box>

            {/* Subtitle */}
            <Typography
                sx={{
                    fontSize: 12,
                    color: "#475569",
                    mb: seats == null ? 2 : 1,
                }}
            >
                {duration}
            </Typography>

            {/* Seats */}
            {seats !== null && seats !== undefined && (
                <Typography
                    sx={{
                        fontSize: 12,
                        color: "#64748B",
                        mb: 2,
                    }}
                >
                    Seats Left: {seats}
                </Typography>
            )}

            {/* Button */}
            <Button
                fullWidth
                variant="outlined"
                size="small"
                onClick={onAction}
                sx={{
                    height: 34,
                    borderRadius: "8px",

                    borderColor: "#8B7BFF",
                    color: "#6D5DF6",

                    textTransform: "none",
                    fontSize: 13,
                    fontWeight: 500,

                    backgroundColor: "#FFFFFF",

                    "&:hover": {
                        borderColor: "#6D5DF6",
                        backgroundColor: "#F6F4FF",
                    },
                }}
            >
                {buttonText}
            </Button>
        </Box>
    );
}